<template>

<svg width="20" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 ml-2">
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(2 1)" stroke="white" stroke-width="1.5">
                                <circle cx="42.601" cy="11.462" r="5" fill-opacity="1" fill="white">
                                    <animate attributeName="fill-opacity" begin="0s" dur="1.3s" values="1;0;0;0;0;0;0;0" calcMode="linear" repeatCount="indefinite"></animate>
                                </circle>
                                <circle cx="49.063" cy="27.063" r="5" fill-opacity="0" fill="white">
                                    <animate attributeName="fill-opacity" begin="0s" dur="1.3s" values="0;1;0;0;0;0;0;0" calcMode="linear" repeatCount="indefinite"></animate>
                                </circle>
                                <circle cx="42.601" cy="42.663" r="5" fill-opacity="0" fill="white">
                                    <animate attributeName="fill-opacity" begin="0s" dur="1.3s" values="0;0;1;0;0;0;0;0" calcMode="linear" repeatCount="indefinite"></animate>
                                </circle>
                                <circle cx="27" cy="49.125" r="5" fill-opacity="0" fill="white">
                                    <animate attributeName="fill-opacity" begin="0s" dur="1.3s" values="0;0;0;1;0;0;0;0" calcMode="linear" repeatCount="indefinite"></animate>
                                </circle>
                                <circle cx="11.399" cy="42.663" r="5" fill-opacity="0" fill="white">
                                    <animate attributeName="fill-opacity" begin="0s" dur="1.3s" values="0;0;0;0;1;0;0;0" calcMode="linear" repeatCount="indefinite"></animate>
                                </circle>
                                <circle cx="4.938" cy="27.063" r="5" fill-opacity="0" fill="white">
                                    <animate attributeName="fill-opacity" begin="0s" dur="1.3s" values="0;0;0;0;0;1;0;0" calcMode="linear" repeatCount="indefinite"></animate>
                                </circle>
                                <circle cx="11.399" cy="11.462" r="5" fill-opacity="0" fill="white">
                                    <animate attributeName="fill-opacity" begin="0s" dur="1.3s" values="0;0;0;0;0;0;1;0" calcMode="linear" repeatCount="indefinite"></animate>
                                </circle>
                                <circle cx="27" cy="5" r="5" fill-opacity="0" fill="white">
                                    <animate attributeName="fill-opacity" begin="0s" dur="1.3s" values="0;0;0;0;0;0;0;1" calcMode="linear" repeatCount="indefinite"></animate>
                                </circle>
                            </g>
                        </g>
                    </svg>
  </template>
  
  <script>
  export default {
    name: "ButtonProcess",
    data: function () {
      return {
      };
    },
    methods: {


    },
  };
  </script>
  
  <style scope>
  @media (min-width: 768px) {
    .md\:w-1\/2 {
      width: 25%;
    }
  
    .md\:w-1\/3 {
      width: 33.333333%;
    }
  
    .md\:w-1\/4 {
      width: 50%;
    }
  
    .md\:w-1\/5 {
      width: 75%;
    }
  }
  
  .border-radius-15 {
    border-radius: 15px;
  }
  
  .close {
    position: absolute;
    right: 12px;
    margin-top: -10px;
  }
  
  .vs--error {
    border: 1px solid red;
    border-radius: 4px;
  }
  </style>